import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

const AssetsIcon: React.FC<Props> = ({ className, ...props }) => (
  <svg
    className={className}
    viewBox="9.78 11.39 20.44 15.08"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse
      cx="19.808"
      cy="19"
      rx="19.808"
      ry="19"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M21.604 20.078a2.652 2.652 0 01-1.948-.802 2.652 2.652 0 01-.802-1.948c0-.764.268-1.413.802-1.948a2.651 2.651 0 011.948-.802 2.65 2.65 0 011.948.802 2.65 2.65 0 01.802 1.948c0 .764-.267 1.413-.802 1.948a2.651 2.651 0 01-1.948.802zm-6.898 3.208c-.473 0-.882-.172-1.226-.516a1.673 1.673 0 01-.516-1.226v-8.41c0-.489.172-.901.516-1.238a1.694 1.694 0 011.226-.503H28.48c.49 0 .902.167 1.238.503.336.337.504.75.504 1.238v8.41c0 .474-.168.883-.504 1.226a1.663 1.663 0 01-1.238.516H14.706zm2.063-1.673h9.648c0-.596.206-1.1.618-1.512a2.057 2.057 0 011.513-.619v-4.286c-.596 0-1.1-.21-1.512-.63a2.07 2.07 0 01-.62-1.5H16.77a2.07 2.07 0 01-.62 1.5c-.412.42-.916.63-1.512.63v4.286c.596 0 1.1.206 1.513.619.412.412.619.916.619 1.512zm-5.248 4.858c-.49 0-.902-.168-1.238-.503a1.684 1.684 0 01-.504-1.238v-9.442c0-.244.084-.45.252-.619a.84.84 0 01.619-.251.84.84 0 01.619.252.841.841 0 01.252.618v9.442h14.941a.84.84 0 01.62.252.841.841 0 01.251.619c0 .244-.084.45-.252.619a.841.841 0 01-.619.251H11.521zm3.116-4.858v-8.548 8.548z"
      fill="currentColor"
    />
  </svg>
);

export default AssetsIcon;
